import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import {
    Container
} from "reactstrap"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import EmailEditor from 'react-email-editor';
//i18n
import { withTranslation } from "react-i18next"
import sample from '../../common/data/sample.json';
import { CreateNewMasterEmail } from "../../store/templates/actions"
import axios from "axios"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import RsLink from "components/buttons/rsLink";
class UnlayerEditor extends Component {
    constructor(props) {
        super(props);
        this.editor = null;
        this.isEditorLoaded = false;
        this.isComponentMounted = false;
        this.state = {
            templateName : ''
        }
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(event) {
        this.setState({ templateName: event.target.value });
      }
    
    componentDidMount() {
        this.isComponentMounted = true;
        this.loadTemplate();
    }
    onLoad = () => { this.isEditorLoaded = true; this.loadTemplate(); }
    handleOnClick = () => {
        loadTemplate = () => { if (!this.isEditorLoaded || !this.isComponentMounted) return; this.editor.loadDesign(tem1) }
    }

    loadTemplate = () => { if (!this.isEditorLoaded || !this.isComponentMounted) return; this.editor.loadDesign(sample) }

    exportHtml = () => {
        const { templateName } = this.state;
        
        var d = {};
        this.editor.exportHtml((data) => {
          d = {
            'agentId' : parseInt(localStorage.getItem("userId")),
            'templateTitle' : templateName,
            'templateType' : parseInt(this.props.match.params.campType)  || 0,
            'templateContent' : JSON.stringify(data.design),
            'templateCSS' : data.html
          }
          //(d, this.props.history)

          const obj = JSON.parse(localStorage.getItem("authUser"));
          const token = obj.resultData.bearerToken;
          const str = 'Bearer ' + token;
          const headers = {
              'Content-Type': 'application/json',
              'Authorization': str
          }
          //const da =  JSON.stringify(d)
          //
          toast.loading("Please wait...");
          axios.post('https://rscoreapi.azurewebsites.net/api/ProjectEmailTemplate', d, {
              headers: headers
            })
            .then((response) => {
                const res = response.data;
                toast.dismiss();
                if (res.success == true) {
                    toast.success("Template Added");
                    this.props.history.push(`/campaign-detail/${this.props.match.params.campType}`)
                }else{
                    toast.warn(res.validationErrors[0]);
                }
                //this.props.history('/');
            })
            .catch((error) => {
             
            }) 
        });
      };
    //   handleImageUpload = (file) => {
      
    //     const formData = new FormData();
    //     formData.append('image', file);
    
    //     // Send image file to server endpoint
    //     return axios.post('/upload-image', formData)
    //         .then(response => {
    //             // Return URL of the uploaded image
    //             return response.data.imageUrl;
    //         })
    //         .catch(error => {
    //             console.error('Error uploading image:', error);
    //             throw new Error('Failed to upload image');
    //         });
    // };
    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Email Composer | Realty Space</title>
                    </MetaTags>
                    <ToastContainer autoClose={2000} />
                    <Container fluid>
                        {/* Render Breadcrumb */}
                        <Breadcrumbs
                            title={this.props.t("Email")}
                            breadcrumbItem={this.props.t("Email Composer")}
                        />
                    </Container>
                    <div style={{ height: '800px', marginTop:20}}>
                    <RsLink className="btn btn-light btn-md" iconClass="bx bx-arrow-back" to={`/campaign-detail/`+ this.props.match.params.campType}>
                                                Back
                    </RsLink>
                  
                    <div className="row" style={{marginBottom:20, marginTop:20}}>
                            <div className="col-sm-3">
                            <label htmlFor="templateName">Template Name *</label>
                            <input type="text" className="form-control" name="templateName" id="templateName" onChange={this.handleChange} />
                            </div>
                             <div className="col-sm-6">
                            <button onClick={this.exportHtml} className="btn btn-create-email btn-primary" style={{marginTop:30, borderRadius:'0.25rem'}}>Save Template</button>
                            </div>
                    </div>
                    <EmailEditor projectId={228097} style={{minHeight:800}} ref={editor => this.editor = editor} />
                    </div>
                </div>
            </React.Fragment>
        )
    }



}
UnlayerEditor.propTypes = {
    t: PropTypes.any,
    match:PropTypes.func,
    history:PropTypes.object,
    CreateNewMasterEmail:PropTypes.func

}
export default connect()(withTranslation()(UnlayerEditor))